module.exports = __webpack_public_path__ + "img/特徴-02.305da331.png";